import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { useTheme } from '../context/ThemeContext';
import type { Container, ISourceOptions } from '@tsparticles/engine';

const HeroSection = () => {
    const [init, setInit] = useState(false);
    const { isDarkMode } = useTheme();

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const particlesLoaded = async (container?: Container) => {
        console.log('Particles loaded');
    };

    const options: ISourceOptions = {
        fullScreen: false,
        background: {
            color: {
                value: 'transparent'
            }
        },
        particles: {
            number: {
                value: 80,
                density: {
                    enable: true
                }
            },
            color: {
                value: isDarkMode ? '#ffffff' : '#000000'
            },
            shape: {
                type: 'circle'
            },
            opacity: {
                value: isDarkMode ? 0.3 : 0.15
            },
            size: {
                value: { min: 1, max: 3 }
            },
            links: {
                enable: true,
                distance: 150,
                color: isDarkMode ? '#ffffff' : '#000000',
                opacity: isDarkMode ? 0.2 : 0.1,
                width: 1
            },
            move: {
                enable: true,
                speed: 2,
                direction: 'none',
                random: false,
                straight: false,
                outModes: {
                    default: 'bounce'
                }
            }
        },
        interactivity: {
            events: {
                onHover: {
                    enable: true,
                    mode: 'grab'
                }
            },
            modes: {
                grab: {
                    distance: 200,
                    links: {
                        opacity: isDarkMode ? 0.4 : 0.2
                    }
                }
            }
        }
    };

    return (
        <div className="relative min-h-screen">
            <div className="absolute inset-0 overflow-hidden">
                {init && (
                    <div className="relative h-screen">
                        <Particles
                            id="tsparticles"
                            particlesLoaded={particlesLoaded}
                            options={options}
                            className="absolute inset-0"
                            style={{ height: '100vh' }}
                        />
                    </div>
                )}
            </div>

            <div className="relative z-10 min-h-screen flex items-center justify-center px-4">
                <div className="text-center max-w-4xl mx-auto pt-16">
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 dark:text-white mb-4"
                    >
                        Bienvenue chez{' '}
                        <span className="text-blue-600 dark:text-blue-400">Kolabo Tech</span>
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        className="text-xl text-gray-600 dark:text-gray-300 mb-8"
                    >
                        Transformer vos idées en réalité numérique avec des solutions innovantes
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.4 }}
                    >
                        <a
                            href="https://forms.gle/vSwKKrNsj4suHS35A"
                            // href="/contact"
                            className="group relative inline-flex items-center justify-center px-8 py-3 font-mono font-medium tracking-wider overflow-hidden rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-blue-500/40 active:scale-100"
                        >
                            <span className="absolute -top-5 -left-5 h-40 w-40 rounded-full bg-gradient-to-br from-blue-600 to-blue-400 blur-2xl group-hover:opacity-70 transition-opacity duration-500 opacity-40"></span>
                            <span className="absolute inset-0 h-full w-full bg-gradient-to-br from-[rgba(255,255,255,0.12)] to-[rgba(255,255,255,0.08)] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                            <span className="relative flex items-center gap-2">
                                <span className="animate-pulse">{'<'}</span>
                                {/* Commencer un projet */}
                                S'inscrire a Kolabo Edu
                                <span className="animate-pulse">{'>'}</span>
                            </span>
                        </a>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;